import {
  GET_VAT_SETTING_LIST,
  GET_VAT_SETTING_LIST_SUCCESS,
  GET_VAT_SETTING_LIST_FAILED,
  CREATE_VAT_SETTING,
  CREATE_VAT_SETTING_SUCCESS,
  CREATE_VAT_SETTING_FAILED,
  UPDATE_VAT_SETTING,
  UPDATE_VAT_SETTING_SUCCESS,
  UPDATE_VAT_SETTING_FAILED,
} from './actionTypes';

const initialState = {
  vatSettingList: [],
  totalVatSettings: 0,
  isLoadingVatSettingList: false,
  isLoadingCreateVatSetting: false,
  isLoadingUpdateVatSetting: false,
};

const vatSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VAT_SETTING_LIST:
      return {
        ...state,
        isLoadingVatSettingList: true,
      };

    case GET_VAT_SETTING_LIST_SUCCESS: {
      const rawPayload = action.payload;
      const listData = [
        rawPayload,
        rawPayload?.data,
        rawPayload?.payload?.data,
      ].find(Array.isArray) || [];

      return {
        ...state,
        isLoadingVatSettingList: false,
        vatSettingList: listData,
        totalVatSettings: rawPayload?.total || rawPayload?.payload?.total || listData.length,
      };
    }

    case GET_VAT_SETTING_LIST_FAILED:
      return {
        ...state,
        isLoadingVatSettingList: false,
      };

    case CREATE_VAT_SETTING:
      return {
        ...state,
        isLoadingCreateVatSetting: true,
      };

    case CREATE_VAT_SETTING_SUCCESS:
      return {
        ...state,
        isLoadingCreateVatSetting: false,
      };

    case CREATE_VAT_SETTING_FAILED:
      return {
        ...state,
        isLoadingCreateVatSetting: false,
      };

    case UPDATE_VAT_SETTING:
      return {
        ...state,
        isLoadingUpdateVatSetting: true,
      };

    case UPDATE_VAT_SETTING_SUCCESS:
      return {
        ...state,
        isLoadingUpdateVatSetting: false,
      };

    case UPDATE_VAT_SETTING_FAILED:
      return {
        ...state,
        isLoadingUpdateVatSetting: false,
      };

    default:
      return state;
  }
};

export default vatSettingReducer;
